<template>
    <div class="vol-el-menu">
        <el-menu close="vol-el-menu--vertical"
        :unique-opened="true"
        @select="select"
        :collapse="isCollapse"
        @open="handleOpen"
        @close="handleClose">
        
            <template v-for="item in treeList">
                <el-submenu :key="item.id"
                :index="'' + item.id"
                v-if="item.children.length && item.enable == 1">

                    <template slot="title">
                        <i :class="item.icon || 'el-icon-s-grid'"></i>
                        <span slot="title"> {{ item.name }}</span>
                    </template>
                    <maliang-element-menu-child :list="item.children"></maliang-element-menu-child>

                </el-submenu>

                <template v-else>
                    <el-menu-item class="menu-item-lv1"
                    v-if="item.enable == 1"
                    :key="item.id"
                    :index="'' + item.id">
                        <i :class="item.icon || 'el-icon-s-grid'"></i>
                        <span slot="title"> {{ item.name }}</span>
                    </el-menu-item>
                </template>

            </template>

        </el-menu>
    </div>
</template>

<script>
import MaliangElementMenuChild from "./MaliangElementMenuChild";
export default {
    components:{
        "maliang-element-menu-child":MaliangElementMenuChild
    },
    props:{
        isCollapse:{
            type: Boolean,
            default: false,
        },
        onSelect:{
            type: Function,
            default:(x)=>{
                console.log(x);
            }
        },
        list:{
            type: Array,
            default: ()=>{
                return [];
            },
        },
        rootId:{
            type: String,
            default: "0",
        }
    },
    data(){
        return{
            treeList: [],
        }
    },
    created(){
        this.treeList=this.convertTree(this.list);
    },
    methods:{
        convertTree(data){
            var rootId = !isNaN(this.rootId) ? ~~this.rootId : this.rootId;
            var root_data = [];
            data.forEach((x)=>{
                if (!x.children) x.children = [];
                if (x.parentId === rootId){
                    x.isRoot = true;
                    if(!Object.prototype.hasOwnProperty.call(x,'enable')){
                        x.enable = 1;
                    }
                    //if (!x.hasOwnProperty("enable")) x.enable = 1;
                    root_data.push(x);
                    this.getTree(x.id, x, data);
                }
            })
            return root_data;
        },
        getTree(id, node, data){
            data.forEach((x)=>{
                if (!x.hidden && x.parentId == id){
                    if (!node.children){
                        node.children = [];
                    }
                    node.children.push(x);
                    this.getTree(x.id, x, data);
                }
            })
        },
        //indexPath
        select(index){
            //console.log("index",index)
            var route;
            this.list.forEach(item=>{
                if(item.children.length>0){
                    item.children.forEach(child=>{
                        if(child.id==index){
                            route=child;
                        }
                    })
                }else{
                    if(item.id==index){
                        route=item;
                    }
                }
            })
            let _item=route;
            //保存
            this.$store.commit('setUrlTitle', _item.name);

            //console.log("_item",_item);
            //this.onSelect(index, _item);
            this.$router.push({ path: _item.path });
        },
        handleOpen(){

        },
        handleClose(){

        },
    }
}
</script>
<style scoped>
.vol-el-menu {
  box-sizing: content-box;
  width: 100%;
}
.vol-el-menu >>> .el-menu-item-group__title {
  padding: 0 !important;
}
.vol-el-menu >>> .horizontal-collapse-transition {
  transition: 0s width ease-in-out, 0s padding-left ease-in-out,
    0s padding-right ease-in-out;
}
</style>